import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

/**
 * CBox - A wrapper for MUI Box with additional functionality
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content of the box
 * @param {Object} props.sx - Additional styling for the box
 * @param {Object} props.theme - Theme object for styling
 * @returns {JSX.Element}
 */
const CBox = ({
  children,
  sx = {},
  theme,
  ...rest
}) => {
  // Default styles based on theme (if provided)
  const defaultSx = theme
    ? {
        // Add any theme-specific default styling here
      }
    : {};

  return (
    <Box
      sx={{ ...defaultSx, ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
};

CBox.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  theme: PropTypes.object,
};

export default CBox;